import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  key: 1
};
var _hoisted_2 = ["id"];
var _hoisted_3 = ["onClick", "onLongpress", "onContextmenu"];
var _hoisted_4 = {
  class: "left"
};
var _hoisted_5 = {
  key: 1,
  class: "num"
};
var _hoisted_6 = {
  key: 2,
  class: "num-notify"
};
var _hoisted_7 = {
  class: "content"
};
var _hoisted_8 = {
  class: "content-header"
};
var _hoisted_9 = {
  class: "content-header-label"
};
var _hoisted_10 = {
  class: "name"
};
var _hoisted_11 = {
  class: "middle-box"
};
var _hoisted_12 = {
  key: 0,
  class: "middle-box-at"
};
var _hoisted_13 = {
  class: "middle-box-content"
};
var _hoisted_14 = {
  class: "content-footer"
};
var _hoisted_15 = {
  class: "time"
};
var _hoisted_16 = {
  key: 2
};
var _hoisted_17 = ["id"];
var _hoisted_18 = ["onClick", "onLongpress", "onContextmenu"];
var _hoisted_19 = {
  class: "left"
};
var _hoisted_20 = {
  key: 1,
  class: "num"
};
var _hoisted_21 = {
  key: 2,
  class: "num-notify"
};
var _hoisted_22 = {
  class: "content"
};
var _hoisted_23 = {
  class: "content-header"
};
var _hoisted_24 = {
  class: "content-header-label"
};
var _hoisted_25 = {
  class: "name"
};
var _hoisted_26 = {
  class: "middle-box"
};
var _hoisted_27 = {
  key: 0,
  class: "middle-box-at"
};
var _hoisted_28 = {
  class: "middle-box-content"
};
var _hoisted_29 = {
  class: "content-footer"
};
var _hoisted_30 = {
  class: "time"
};
import { ref, onMounted, onUnmounted, watchEffect } from '../../../adapter-vue';
import TUIChatEngine, { TUIStore, StoreName, TUIConversationService } from '@tencentcloud/chat-uikit-engine';
import { TUIGlobal, isIOS, addLongPressListener } from '@tencentcloud/universal-api';
import Icon from '../../common/Icon.vue';
import Avatar from '../../common/Avatar/index.vue';
import ActionsMenu from '../actions-menu/index.vue';
import muteIcon from '../../../assets/icon/mute.svg';
import { isPC, isH5, isUniFrameWork, isMobile } from '../../../utils/env';
import { useRouter } from 'vue-router';
import { getTimeShowLable } from '@/util/tim';
import { useTimStore } from '../../../../store/tim';
import { search_obscure } from "../../../../util/index";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['handleSwitchConversation', 'getPassingRef'],
  setup(__props, _ref) {
    var {
      expose: __expose,
      emit: __emit
    } = _ref;
    var timStore = useTimStore();
    var searchList = ref([]);
    var router = useRouter();
    var emits = __emit;
    var currentConversation = ref();
    var currentConversationID = ref();
    var currentConversationDomRect = ref();
    var isShowOverlay = ref(false);
    var conversationList = ref([]);
    var conversationListDomRef = ref();
    var conversationListInnerDomRef = ref();
    var actionsMenuPosition = ref({
      top: 0,
      left: undefined,
      conversationHeight: undefined
    });
    var displayOnlineStatus = ref(false); // 在线状态 默认关闭
    var userOnlineStatusMap = ref();
    var lastestOpenActionsMenuTime = null;
    onMounted(() => {
      TUIStore.watch(StoreName.CONV, {
        currentConversationID: onCurrentConversationIDUpdated,
        conversationList: onConversationListUpdated,
        currentConversation: onCurrentConversationUpdated
      });
      // 初始状态
      TUIStore.watch(StoreName.USER, {
        displayOnlineStatus: onDisplayOnlineStatusUpdated,
        userStatusList: onUserStatusListUpdated
      });
      if (!isUniFrameWork && isIOS && !isPC) {
        addLongPressHandler();
      }
    });
    watchEffect(() => {
      if (timStore.keyword) {
        console.log("关键词是->", timStore.keyword);
        var two_keys = ['nick', 'userID', 'name', 'fromAccount', 'description', 'text', 'messageForShow'];
        var one_keys = ['lastMessage', 'userProfile', 'groupProfile'];
        if (conversationList.value && conversationList.value[0]) {
          console.log('conversationList.value->', conversationList.value);
          searchList.value = search_obscure(timStore.keyword, conversationList.value, one_keys, two_keys);
          console.log("searchList.value-->", searchList.value);
        }
      }
    });
    onUnmounted(() => {
      TUIStore.unwatch(StoreName.CONV, {
        currentConversationID: onCurrentConversationIDUpdated,
        conversationList: onConversationListUpdated,
        currentConversation: onCurrentConversationUpdated
      });
      // 初始状态
      TUIStore.unwatch(StoreName.USER, {
        displayOnlineStatus: onDisplayOnlineStatusUpdated,
        userStatusList: onUserStatusListUpdated
      });
    });
    var isShowUserOnlineStatus = conversation => {
      return displayOnlineStatus.value && conversation.type === TUIChatEngine.TYPES.CONV_C2C;
    };
    var showConversationActionMenu = (event, conversation, index, isContextMenuEvent) => {
      if (isContextMenuEvent) {
        event.preventDefault();
        if (isUniFrameWork) {
          return;
        }
      }
      currentConversation.value = conversation;
      lastestOpenActionsMenuTime = Date.now();
      getActionsMenuPosition(event, index);
    };
    var closeConversationActionMenu = () => {
      // 防止连续触发overlay的tap事件
      if (lastestOpenActionsMenuTime && Date.now() - lastestOpenActionsMenuTime > 300) {
        currentConversation.value = undefined;
        isShowOverlay.value = false;
      }
    };
    var getActionsMenuPosition = (event, index) => {
      if (isUniFrameWork) {
        if (typeof conversationListDomRef.value === 'undefined') {
          emits('getPassingRef', conversationListDomRef);
        }
        var query = TUIGlobal === null || TUIGlobal === void 0 ? void 0 : TUIGlobal.createSelectorQuery().in(conversationListDomRef.value);
        query.select("#convlistitem-".concat(index)).boundingClientRect(data => {
          if (data) {
            actionsMenuPosition.value = {
              // uni-h5的uni-page-head不被认为是视窗中的成员，因此手动上head的高度
              top: data.bottom + (isH5 ? 44 : 0),
              // @ts-expect-error in uniapp event has touches property
              left: event.touches[0].pageX,
              conversationHeight: data.height
            };
            isShowOverlay.value = true;
          }
        }).exec();
      } else {
        var _ref2;
        // 处理Vue原生
        var rect = ((_ref2 = event.currentTarget || event.target) === null || _ref2 === void 0 ? void 0 : _ref2.getBoundingClientRect()) || {};
        if (rect) {
          actionsMenuPosition.value = {
            top: rect.bottom,
            left: isPC ? event.clientX : undefined,
            conversationHeight: rect.height
          };
        }
        isShowOverlay.value = true;
      }
    };
    var enterConversationChat = (conversationID, own) => {
      if (!own || own == '' || own == undefined) {
        router.push("/instant_messages");
      }
      emits('handleSwitchConversation', conversationID);
      TUIConversationService.switchConversation(conversationID);
    };
    function addLongPressHandler() {
      if (!conversationListInnerDomRef.value) {
        return;
      }
      addLongPressListener({
        element: conversationListInnerDomRef.value,
        onLongPress: (event, target) => {
          var index = Array.from(conversationListInnerDomRef.value.children).indexOf(target);
          showConversationActionMenu(event, conversationList.value[index], index);
        },
        options: {
          eventDelegation: {
            subSelector: '.tui-conversation-content'
          }
        }
      });
    }
    function onCurrentConversationUpdated(conversation) {
      currentConversation.value = conversation;
      console.log("currentConversation->", currentConversation.value);
    }
    function onConversationListUpdated(list) {
      // if (!currentConversationID.value) {
      //   console.log("不存在当前会话id");
      //   enterConversationChat(list[0].conversationID, '')
      // }
      conversationList.value = list;
    }
    function onCurrentConversationIDUpdated(id) {
      currentConversationID.value = id;
    }
    function onDisplayOnlineStatusUpdated(status) {
      displayOnlineStatus.value = status;
    }
    function onUserStatusListUpdated(list) {
      if (list.size !== 0) {
        userOnlineStatusMap.value = [...list.entries()].reduce((obj, _ref3) => {
          var [key, value] = _ref3;
          obj[key] = value;
          return obj;
        }, {});
      }
    }
    // 监听导航栏路由变化
    watchEffect(() => {
      if (router.currentRoute) {
        if (router.currentRoute.value.query.groupID) {
          var groupID = router.currentRoute.value.fullPath.split("=")[1];
          var conversationID_ = 'GROUP' + groupID;
          if (conversationID_ != currentConversationID.value) {
            console.log("页面上传值了，有groupId ，且传过来的groupid不等于当前groupid");
            if (conversationList.value && conversationList.value[0]) {
              // let last_c = conversationList.value[conversationList.value.length - 1];
              // currentConversationID.value = last_c.conversationID;
              // currentConversation = ref<IConversationModel>();
              // 由于状态不刷新先这样写
              // enterConversationChat(last_c.conversationID, '')
              setTimeout(() => {
                currentConversationID.value = conversationID_;
                enterConversationChat(conversationID_, '');
              }, 500);
            }
          }
        } else {
          if (!currentConversationID.value) {
            console.log("不存在当前会话id");
            if (conversationList.value && conversationList.value[0]) {
              var _conversationList$val;
              enterConversationChat((_conversationList$val = conversationList.value[0]) === null || _conversationList$val === void 0 ? void 0 : _conversationList$val.conversationID, '');
            }
          }
        }
      }
    });
    // 暴露给父组件，当监听到滑动事件时关闭actionsMenu
    __expose({
      closeChildren: closeConversationActionMenu
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "conversationListInnerDomRef",
        ref: conversationListInnerDomRef,
        class: "tui-conversation-list"
      }, [_unref(isShowOverlay) ? (_openBlock(), _createBlock(ActionsMenu, {
        key: 0,
        selectedConversation: _unref(currentConversation),
        actionsMenuPosition: _unref(actionsMenuPosition),
        selectedConversationDomRect: _unref(currentConversationDomRect),
        onCloseConversationActionMenu: closeConversationActionMenu
      }, null, 8, ["selectedConversation", "actionsMenuPosition", "selectedConversationDomRect"])) : _createCommentVNode("", true), !_unref(timStore).keyword || _unref(timStore).keyword == undefined || _unref(timStore).keyword == '' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(conversationList), (conversation, index) => {
        var _conversation$lastMes;
        return _openBlock(), _createElementBlock("div", {
          id: "convlistitem-".concat(index),
          key: index,
          class: _normalizeClass(['tui-conversation-content', _unref(isMobile) && 'tui-conversation-content-h5 disable-select'])
        }, [_createElementVNode("div", {
          class: _normalizeClass([_unref(isPC) && 'isPC', 'tui-conversation-item', _unref(currentConversationID) === conversation.conversationID && 'tui-conversation-item-selected', conversation.isPinned && 'tui-conversation-item-pinned']),
          onClick: $event => enterConversationChat(conversation.conversationID, ''),
          onLongpress: $event => showConversationActionMenu($event, conversation, index),
          onContextmenu: $event => showConversationActionMenu($event, conversation, index, true)
        }, [_createElementVNode("aside", _hoisted_4, [_createVNode(Avatar, {
          useSkeletonAnimation: "",
          url: conversation.getAvatar(),
          size: "30px"
        }, null, 8, ["url"]), _unref(userOnlineStatusMap) && isShowUserOnlineStatus(conversation) ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['online-status', Object.keys(_unref(userOnlineStatusMap)).length > 0 && Object.keys(_unref(userOnlineStatusMap)).includes(conversation.userProfile.userID) && _unref(userOnlineStatusMap)[conversation.userProfile.userID].statusType === 1 ? 'online-status-online' : 'online-status-offline'])
        }, null, 2)) : _createCommentVNode("", true), conversation.unreadCount > 0 && !conversation.isMuted ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(conversation.unreadCount > 99 ? "99+" : conversation.unreadCount), 1)) : _createCommentVNode("", true), conversation.unreadCount > 0 && conversation.isMuted ? (_openBlock(), _createElementBlock("span", _hoisted_6)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("label", _hoisted_9, [_createElementVNode("p", _hoisted_10, _toDisplayString(conversation.getShowName()), 1)]), _createElementVNode("div", _hoisted_11, [conversation.type === 'GROUP' && conversation.groupAtInfoList && conversation.groupAtInfoList.length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(conversation.getGroupAtInfo()), 1)) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_13, _toDisplayString(conversation.getLastMessage("text")), 1)])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(_unref(getTimeShowLable)((_conversation$lastMes = conversation.lastMessage) === null || _conversation$lastMes === void 0 ? void 0 : _conversation$lastMes.lastTime)), 1), conversation.isMuted ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          file: _unref(muteIcon)
        }, null, 8, ["file"])) : _createCommentVNode("", true)])])], 42, _hoisted_3)], 10, _hoisted_2);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchList), (conversation, index) => {
        var _conversation$lastMes2;
        return _openBlock(), _createElementBlock("div", {
          id: "convlistitem-".concat(index),
          key: index,
          class: _normalizeClass(['tui-conversation-content', _unref(isMobile) && 'tui-conversation-content-h5 disable-select'])
        }, [_createElementVNode("div", {
          class: _normalizeClass([_unref(isPC) && 'isPC', 'tui-conversation-item', _unref(currentConversationID) === conversation.conversationID && 'tui-conversation-item-selected', conversation.isPinned && 'tui-conversation-item-pinned']),
          onClick: $event => enterConversationChat(conversation.conversationID, ''),
          onLongpress: $event => showConversationActionMenu($event, conversation, index),
          onContextmenu: $event => showConversationActionMenu($event, conversation, index, true)
        }, [_createElementVNode("aside", _hoisted_19, [_createVNode(Avatar, {
          useSkeletonAnimation: "",
          url: conversation.getAvatar(),
          size: "30px"
        }, null, 8, ["url"]), _unref(userOnlineStatusMap) && isShowUserOnlineStatus(conversation) ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['online-status', Object.keys(_unref(userOnlineStatusMap)).length > 0 && Object.keys(_unref(userOnlineStatusMap)).includes(conversation.userProfile.userID) && _unref(userOnlineStatusMap)[conversation.userProfile.userID].statusType === 1 ? 'online-status-online' : 'online-status-offline'])
        }, null, 2)) : _createCommentVNode("", true), conversation.unreadCount > 0 && !conversation.isMuted ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(conversation.unreadCount > 99 ? "99+" : conversation.unreadCount), 1)) : _createCommentVNode("", true), conversation.unreadCount > 0 && conversation.isMuted ? (_openBlock(), _createElementBlock("span", _hoisted_21)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("label", _hoisted_24, [_createElementVNode("p", _hoisted_25, _toDisplayString(conversation.getShowName()), 1)]), _createElementVNode("div", _hoisted_26, [conversation.type === 'GROUP' && conversation.groupAtInfoList && conversation.groupAtInfoList.length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(conversation.getGroupAtInfo()), 1)) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_28, _toDisplayString(conversation.getLastMessage("text")), 1)])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("span", _hoisted_30, _toDisplayString(_unref(getTimeShowLable)((_conversation$lastMes2 = conversation.lastMessage) === null || _conversation$lastMes2 === void 0 ? void 0 : _conversation$lastMes2.lastTime)), 1), conversation.isMuted ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          file: _unref(muteIcon)
        }, null, 8, ["file"])) : _createCommentVNode("", true)])])], 42, _hoisted_18)], 10, _hoisted_17);
      }), 128))]))], 512);
    };
  }
});